import axios from "axios";

export const getVideo = axios.create({
	baseURL:
		"https://www.twvip.org/loveandhappiness/api/announcements/15/resource/content/image/detail_cover.mp4/",
	method: "GET",
	responseType: "arraybuffer"
});
